(function () {
  function initGalleryV2(root) {
    const items = root.querySelectorAll('.youtube-item');
    const mainPlayer = root.querySelector('.youtube-main-player');

    function getYouTubeId(href) {
      try {
        const url = new URL(href);
        const v = url.searchParams.get('v');
        if (v) return v;
        if (url.hostname.includes('youtu.be')) return url.pathname.replace('/', '');
        const m = url.pathname.match(/\/embed\/([^/?]+)/);
        return m ? m[1] : '';
      } catch (e) { return ''; }
    }

    function playVideo(id) {
      mainPlayer.innerHTML = `
        <iframe 
          src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen>
        </iframe>`;
    }

    // 初始化：填充缩略图并加载第一个视频
    items.forEach((item, index) => {
      const url = item.getAttribute('data-video-url');
      const id = getYouTubeId(url);
      if (!id) return;

      // 填充图片
      const thumbBox = item.querySelector('.youtube-item-thumb');
      thumbBox.innerHTML = `<img src="https://img.youtube.com/vi/${id}/mqdefault.jpg" loading="lazy">`;

      // 初始加载第一个视频（不自动播放）
      if (index === 0) {
        mainPlayer.innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${id}?rel=0" frameborder="0" allowfullscreen></iframe>`;
      }

      // 点击切换逻辑
      item.addEventListener('click', () => {
        // 移除其他激活状态
        items.forEach(i => i.classList.remove('is-active'));
        item.classList.add('is-active');
        // 播放当前视频
        playVideo(id);
      });
    });
  }

  document.querySelectorAll('[data-youtube-gallery-v2]').forEach(initGalleryV2);
})();